import { userConstants } from "../../constant";

export function sponsorshipProductDetail(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_SPONSORSHIP_PRODUCT_DETAIL:
      return {
        ...state,
        product: action.product,
      };
    case userConstants.GET_CAMPAIGN_UPDATES:
      return {
        ...state,
        updates: action.updates,
      };
    case userConstants.CREATE_CAMPAIGN_UPDATE:
      return {
        ...state,
        updates: [action.update, ...(state.updates || [])],
      };
    case userConstants.GET_CAMPAIGN_REWARDS:
      return {
        ...state,
        rewards: action.rewards,
      };
    case userConstants.GET_CAMPAIGN_RATING:
      return {
        ...state,
        aiRating: action.rating,
        aiRatingReasoning: action.reasoning,
        aiRatedAt: action.rated_at,
      };
    case userConstants.GET_CAMPAIGN_EXTENSION_STATUS:
      return {
        ...state,
        extensionData: action.extensionData,
      };
    case userConstants.REQUEST_CAMPAIGN_EXTENSION:
      return {
        ...state,
        extensionData: action.extensionData,
      };
    default:
      return state;
  }
}
